// Dynamically determine environment
const isDevelopment = (): boolean => {
  if (typeof window !== 'undefined') {
    return window.location.hostname === 'localhost' ||
           window.location.hostname === '127.0.0.1' ||
           window.location.hostname.includes('localhost');
  }
  return false;
};

// Lifetime deal configuration
export const LIFETIME_DEAL_LIMIT = 10; // Only 10 available per plan

// Development Stripe configuration (test mode)
const DEV_STRIPE_CONFIG = {
  publishableKey: 'pk_test_51Rfp18R0HTLAzD8ESPjqiuVPCmDrcXAq1BVVXgv6y9d60AU404DdadBv4ZhWlC76ermb4WUuaevUJPNJRKbVAvrn003UMcbr0n',
  priceIds: {
    starter: {
      monthly: 'price_1Rfp3nR0HTLAzD8EX8uFe4hs',
      yearly: 'price_1RfpYNR0HTLAzD8EOBh6jEyY',
      lifetime: 'price_1StXkAR0HTLAzD8EMqXIVVHX'
    },
    professional: {
      monthly: 'price_1RfpW1R0HTLAzD8EMtmQPLn4',
      yearly: 'price_1RfpW1R0HTLAzD8EMtmQPLn4'
    },
    enterprise: {
      monthly: 'price_1RfpZDR0HTLAzD8EwIBRPqM7',
      yearly: 'price_1RfpZbR0HTLAzD8E0SB2Voov'
    },
    defined: {
      monthly: 'price_1RfpZDR0HTLAzD8EwIBRPqM7',
      yearly: 'price_1RfpZbR0HTLAzD8E0SB2Voov'
    }
  },
  lifetimeDealLimit: LIFETIME_DEAL_LIMIT
};

// Production Stripe configuration (live mode)
const PROD_STRIPE_CONFIG = {
  publishableKey: 'pk_live_ydmLXp2GB54LeZHh3TQ4Zwt1',
  priceIds: {
    starter: {
      monthly: 'price_1RgrY2JYP9Eist9xX2UkTueG',
      yearly: 'price_1RgrY2JYP9Eist9xqoMojmyN',
      lifetime: 'price_1SyxzHJYP9Eist9xs1EI5uTf'
    },
    professional: {
      monthly: 'price_1RgrY0JYP9Eist9xMJfNMPoF',
      yearly: 'price_1RgrY0JYP9Eist9xxVukcusR'
    },
    enterprise: {
      monthly: 'price_1RgrXwJYP9Eist9x0LGl0hPy',
      yearly: 'price_1RgrXwJYP9Eist9xTmrleiF2'
    },
    defined: {
      monthly: 'price_1RyMQkJYP9Eist9xMXI75LUy',
      yearly: 'price_1RyMQkJYP9Eist9xq5eqVrsN'
    }
  },
  lifetimeDealLimit: LIFETIME_DEAL_LIMIT
};

export const STRIPE_CONFIG = isDevelopment() ? DEV_STRIPE_CONFIG : PROD_STRIPE_CONFIG;

// Dynamically determine API base URL based on environment
const getApiBaseUrl = (): string => {
  // Check if we're in development mode
  if (typeof window !== 'undefined') {
    // Development: localhost or 127.0.0.1
    if (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.includes('localhost')) {
      return 'http://localhost:3456';
    }
  }

  // Production: use Heroku URL
  return 'https://dhs-payment-892b3cdec73f.herokuapp.com';
};

export const API_BASE_URL = getApiBaseUrl();
